// 登陆，退出登陆接口
import requestUrl from "./httpUserCenter";


// 登陆-新版用户中心
export const loginIn = data => {
    return requestUrl({
        method: 'post',
        url: '/api/user-center/authentication/pwd',
        data
    })
}

// 获取菜单权限
export const systemRelList = data => {
    return requestUrl({
        method: 'get',
        url: `/api/user-center/user/system/relList`,
        params: data
    })
}

// 修改密码
export const modifyNewPassword = data => {
    return requestUrl({
        method: 'post',
        url: `/api/user-center/user/crm/editPassword`,
        data
    })
}

// 记录登录日志
export const switchLogin = data => {
    return requestUrl({
        method: 'post',
        url: '/api/user-center/authentication/event/switchLogin',
        data,
        noErrorTip: true
    })
}